const COUNTRY = {
  SET_COUNTRY: 'SET_COUNTRY'
}

export default COUNTRY
